export default __webpack_public_path__ + "static/media/user.8fe7b3bb.svg";